import { createAction } from 'redux-actions';

import * as actionTypes from './actionTypes';

export const initialiseStoreDeviceToken = createAction(actionTypes.INITIALISE_STORE_DEVICE_TOKEN);

export const storeDeviceToken = createAction(actionTypes.STORE_DEVICE_TOKEN, token => token);
